import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./CtaBanner.css";
import mascotMoney from "/public/SiteImages/personaje-10-bolivianos.svg";
import history from "../../core/history";
import { HostCtaArrowIcon } from "../Common/Assets/SvgComponent/commonSvgIcon";

function CtaBanner() {
  const handleClick = () => {
    history.push("/become-a-host?mode=new");
  };

  return (
    <section className={s["eh-cta-section"]}>
      <div className={s["eh-cta-section__container"]}>
        <div className={s["eh-cta-banner"]}>
          {/* Left: Mascot with Money */}
          <div className={s["eh-cta-banner__mascot-box"]}>
            <img
              src={mascotMoney}
              alt="Comienza a generar ingresos"
              className={s["eh-cta-banner__mascot-img"]}
            />
          </div>

          {/* Center: Headline & Subtext */}
          <div className={s["eh-cta-banner__content"]}>
            <h3 className={s["eh-cta-banner__title"]}>¿Listo para comenzar?</h3>
            <p className={s["eh-cta-banner__desc"]}>
              Publica tu alojamiento hoy mismo y empieza a recibir huéspedes.
            </p>
          </div>

          {/* Right: Pill Button */}
          <div className={s["eh-cta-banner__action"]}>
            <button
              type="button"
              className={s["eh-cta-banner__btn"]}
              onClick={handleClick}
            >
              Conviértete en anfitrión
              <HostCtaArrowIcon className={s["eh-cta-banner__arrow"]} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(CtaBanner);
